import React, {Suspense} from 'react';
import Layout from './components/Layout/Layout';
import Loading from './components/Loading/Loading';
import {CookiesProvider} from 'react-cookie';
import ErrorBoundary from './components/hoc/ErrorBoundary'

function App() {

    return (
        <ErrorBoundary>
            <CookiesProvider>
                <div className="App">
                    <Suspense fallback={(<Loading/>)}>
                        <Layout/>
                    </Suspense>
                </div>
            </CookiesProvider>
        </ErrorBoundary>
    );
}

export default App;
